export function genQueryString(cond) {
  let _qry = '';

  for (const key in cond) {
    if (Object.hasOwnProperty.call(cond, key)) {
      const value = cond[key];
      _qry += ( _qry === '' ? '' : '&' ) + `${key}=` + encodeURIComponent(value);
    }
  }

  return _qry
}
